import { createApp } from 'vue';
import axios from 'axios';

window.app = createApp();

const $api = axios.create();
$api.defaults.baseURL = App.Api.Url;

app.config.globalProperties.$axios = window.$axios = axios;
app.config.globalProperties.$api = window.$api = $api;

app.component('SubscriptionForm', require('@/components/SubscriptionForm').default);
app.component('ScanTickets', require('@/components/ScanTickets').default);
app.mount('#app');
